import { ApolloClient, InMemoryCache, ApolloLink, defaultDataIdFromObject } from '@apollo/client';

import { createDebug } from '../utils/runtimeDebug';

import { getUrlResolverError, getNetworkErrors, GqlErrors } from './apolloClientErrorHandlers';
import { introspectionToPossibleTypes } from './possibleTypes';
import { apolloTypePolicies } from './typePolicies';

const debug = createDebug('getBrowserApolloClient');

/**
 * @param links
 * @param unionAndInterfaceTypes
 * @param initialState
 */
export function getBrowserApolloClient(
    links: ApolloLink[],
    unionAndInterfaceTypes = {},
    initialState?: any,
): [ApolloClient<any>, () => GqlErrors[]] {
    const errors: GqlErrors[] = [];

    const urlResolverError = getUrlResolverError(errors, debug);
    const networkErrors = getNetworkErrors(errors);

    return [
        new ApolloClient({
            link: ApolloLink.from([urlResolverError, networkErrors, ...links]),
            cache: new InMemoryCache({
                dataIdFromObject: (object: any) => {
                    switch (object.__typename) {
                        case 'EntityUrl':
                            return `${object.type}-${object.id}`;
                        default:
                            return defaultDataIdFromObject(object);
                    }
                },
                possibleTypes: introspectionToPossibleTypes(unionAndInterfaceTypes),
                typePolicies: apolloTypePolicies,
            }).restore(initialState),
        }),
        () => errors,
    ];
}
